module.exports = __webpack_public_path__ + "img/isqan.b5e53dc7.png";